module.exports = __webpack_public_path__ + "static/img/about3.491fab4a.png";